import React from "react";
import styled from 'styled-components';

import Dot from '../data/images/dot.svg';
import { calc4k } from '../utilities';
import { colors, padding } from '../GlobalStyle';

export default function( { data, alertActive } ) {
    const outputRows = () => {
        let rows_html = [];

        data.forEach( ( { price, sub_rows, highlight }, i ) => {
            let subrows_html = [];

            sub_rows.forEach( ( type, ii ) => {
                subrows_html.push( <SubRow key={ `sub-row-${ ii }` }>{ type }</SubRow> );
            } );

            rows_html.push(
                <Row key={ `p-method-${ i }` } highlight={ highlight } alertActive={ alertActive }>
                    <SubRows>{ subrows_html }</SubRows>
                    <Price>{ price }</Price>
                </Row>
            );
        } );

        return rows_html;
    };

    return (
        <PricingTable>
            { outputRows() }
        </PricingTable>
    );
}

const PricingTable = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 ${ padding.side };
    position: relative;
    //margin-bottom: ${ calc4k( 100 ) };
    
    // &::after {
    //     content: '';
    //     padding: 0 ${ padding.side };
    //     position: absolute;
    //     width: calc( 100% - calc( ${ padding.side } * 2 ) );
    //     bottom: 0;
    //     left: ${ padding.side };
    //     height: ${ calc4k( 5 ) };
    //     background-size: ${ calc4k( 20 ) } ${ calc4k( 2 ) };
    //     background-image: url(${ Dot });
    //     backface-visibility: visible;
    //     transform: scale3d(1,1,1);
    // }
`;

const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${ calc4k( 75 ) } 0;
    position: relative;
    color: ${ p => p.highlight ? colors.gold : colors.white };
    transition: font-size 600ms ease;
    font-size: ${ p => p.alertActive ?  calc4k( 50 ) : calc4k( 60 ) };
    
    &::before {
        content: '';
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        height: ${ calc4k( 5 ) };
        background-size: ${ calc4k( 20 ) } ${ calc4k( 3 ) };
        background-image: url(${ Dot });
        background-repeat: repeat-x;
        backface-visibility: visible;
        transform: scale3d(1,1,1);
    }
    
    &:last-of-type::after {
        content: '';
        padding: 0 ${ padding.side };
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        height: ${ calc4k( 5 ) };
        background-size: ${ calc4k( 20 ) } ${ calc4k( 2 ) };
        background-image: url(${ Dot });
        backface-visibility: visible;
        transform: scale3d(1,1,1);
    }
`;

const Price = styled.div`
    
`;

const SubRows = styled.div`
    
`;

const SubRow = styled.div`
    &:not(:last-of-type) {
        margin-bottom: ${ calc4k( 30 ) };
    }
`;